<div class="row mt-4">
    <div class="col-6 mt-2"><b>Vehicle Detail</b></div>
    <div *ngIf="!vehicleData" class="col-6 pl-0 text-right">
        <!-- <button class="btn btn-primary" (click)="openLinkDeviceToVehicleModal()">Link to vehicle</button> -->
        <button class="btn btn-primary" (click)="openLinkDeviceToVehicleModal()">Link vehicle</button>
    </div>
</div>
<div class="row mb-2 no-gutters">
    <div class="col">
        <!-- <div class="row no-gutters bg-light">
            <div class="col p-2 font14-600">
                <span>Vehicle Detail</span>
            </div> -->

        <!-- <div class="col-sm-4 col-5 p-2 text-right my-auto">
                <small><i class="fas fa-times pointer ml-2 text-secondary" (click)="closeClicked()"
                        data-toggle="tooltip" data-placement="right" title="Close"></i></small>
            </div> -->
        <!-- </div> -->

        <!-- <div *ngIf="deviceData"> -->
        <div *ngIf="vehicleData else noVehicleData">
            <div class="row mt-3 bg-light no-gutters mx-0 py-2 border-bottom-grey">
                <div class="col-lg-1 col-md-1 col-1 my-auto px-1">
                    <img class="logo-14" src="{{getVehicleLogo(vehicleData)}}" alt="logo" />
                </div>

                <div class="col-lg-4 col-md-4 col-4">
                    <div class="font13-600">{{vehicleData.vin}}</div>
                    <div class="font13-400 mt-1">{{vehicleData.make}}&nbsp;{{vehicleData.model}}&nbsp;</div>
                </div>

                <div class="col-lg-4 col-md-4 col-4 text-left">
                    <div class="font13-400">Color</div>
                    <div class="font13-600 mt-1">{{vehicleData.color}}</div>
                </div>

                <div class="col-lg-3 col-md-3 col-3 text-left">
                    <div class="font13-400">
                        <span *ngIf="vehicleData.trimName">Trim / </span>
                        <span>Year Built</span>
                        <span *ngIf="deviceData.telematicsType == 'AFTER_MARKET'" class="pr-4 pl-0 pull-right">
                            <span>
                                <i class="fa fa-trash cursor-pointer maroon" data-toggle="tooltip" data-placement="right"
                                    title="Delete" (click)="openConfirmUnlinkVehicleModal()"></i>
                            </span>
                        </span>
                    </div>
                    <div class="font13-600 mt-1"><span *ngIf="vehicleData.trimName">{{vehicleData.trimName}} /
                        </span>{{vehicleData.year}}</div>
                </div>

                <!-- <div *ngIf="deviceData.telematicsType == 'AFTER_MARKET'" class="col-lg-1 col-md-1 col-1 pr-4 pl-0 text-right">
                    <span class="pull-right">
                        <i class="fa fa-trash cursor-pointer maroon" data-toggle="tooltip" data-placement="right"
                            title="Delete" (click)="openConfirmUnlinkVehicleModal()"></i>
                    </span>
                </div> -->
            </div>
        </div>
        <ng-template #noVehicleData>
            <div class="mt-2 font13-400">
                {{noDeviceVehicleMessage}}
            </div>
        </ng-template>
    </div>
</div>

<app-confirmation-modal [modalId]="confirmationModalAttributes.modalId"
    [modalOpenButtonId]="confirmationModalAttributes.modalOpenButtonId"
    [modalCloseButtonId]="confirmationModalAttributes.modalCloseButtonId"
    [modalHeader]="confirmationModalAttributes.modalHeader" [content]="confirmationModalAttributes.content"
    (saveEmitter)="onConfirm($event)" (cancelEmitter)="onCancel($event)" #confirmationModal>
</app-confirmation-modal>

<app-link-device-to-vehicle-modal [modalId]="linkDeviceToVehicleModalAttributes.modalId"
    [modalOpenButtonId]="linkDeviceToVehicleModalAttributes.modalOpenButtonId"
    [modalCloseButtonId]="linkDeviceToVehicleModalAttributes.modalCloseButtonId"
    [modalHeader]="linkDeviceToVehicleModalAttributes.modalHeader"
    [content]="linkDeviceToVehicleModalAttributes.content" [deviceData]="linkDeviceToVehicleModalAttributes.deviceData"
    (linkToVehicleSuccessEmitter)="onlinktoVehicleSuccess($event)" #linkDeviceToVehicleModal>

</app-link-device-to-vehicle-modal>